import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";


// 👇 Combine the interfaces to represent a full video Topic item
export type IVideoTopic = any;

export const VideoLessonAnalyticsSlice = createSlice({
  name: "VideoLessonAnalyticsSlice",
  initialState: {} as IReduxState<IVideoTopic>,
  reducers: {
    VideoLessonAnalytics: (state, action) => {
      state.isLoading = true;
    },

    successVideoLessonAnalytics: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureVideoLessonAnalytics: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearVideoLessonAnalytics: (state) => {
      state.data = {};
    },
  },
});

export const {
  VideoLessonAnalytics,
  successVideoLessonAnalytics,
  failureVideoLessonAnalytics,
  clearVideoLessonAnalytics,
} = VideoLessonAnalyticsSlice.actions;

export default VideoLessonAnalyticsSlice.reducer;
